import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import './AddingMinutesPage.css';
import GetTimeslotsActions from '../../../redux/GetTimeslotsRedux';
import GetListLeaveActions from '../../../redux/GetListLeaveRedux';
import UpdateMakeActions from '../../../redux/UpdateMakeRedux';
import moment from 'moment';
import { ArrowLeft } from '../../../assets/icons';
import ConfirmBox from '../../../components/ConfirmBox';

// Interface for props
interface AddingMinutesPageProps {
  t?: any;
  // Redux props - matching reference exactly
  currentSettings?: any;
  getListLeaveFetching?: boolean;
  getListLeaveSuccess?: boolean;
  getListLeaveError?: boolean;
  listLeave?: any;
  getTimeslotsFetching?: boolean;
  getTimeslotsSuccess?: boolean;
  getTimeslotsError?: boolean;
  timeslotsNew?: any[];
  timeslotsMake?: any[];
  updateMakeFetching?: boolean;
  updateMakeSuccess?: boolean;
  updateMakeError?: boolean;
  // Navigation props - from wrapper
  leave_id?: string;
  isTherapist?: boolean;
  isReschedule?: boolean;
  make_id?: string;
  code?: string;
  categoryId?: string;
  childId?: string;
  onNavigate?: (route: string, params?: any) => void;
  onGoBack?: () => void;
  // Redux actions
  getTimeslots?: (leave_id: string, isTherapist: boolean, children_id: string, isReschedule: boolean, makeId: string, page?: number) => void;
  getListLeave?: (children_id: string, page: number) => void;
  updateMake?: (make_id: string, make: any) => void;
}

interface AddingMinutesPageState {
  dataLeave: any;
  page: number;
  fruits: any[];
  checkbox: boolean;
  // Phase 5: Pull-to-refresh state
  isRefreshing: boolean;
  startY: number;
  currentY: number;
  pullDistance: number;
  confirmBoxPopupBeforeSession: boolean;
}

class AddingMinutesPage extends Component<AddingMinutesPageProps, AddingMinutesPageState> {
  constructor(props: AddingMinutesPageProps) {
    super(props);
    
    // API calls - matching reference exactly
    if (this.props.getListLeave && this.props.currentSettings?.child?.salesforce_contact_id) {
      this.props.getListLeave(
        this.props.currentSettings.child.salesforce_contact_id,
        1
      );
    }

    if (this.props.getTimeslots && this.props.leave_id && this.props.currentSettings?.child?.salesforce_contact_id) {
      this.props.getTimeslots(
        this.props.leave_id,
        this.props.isTherapist || false,
        this.props.currentSettings.child.salesforce_contact_id,
        this.props.isReschedule || false,
        this.props.make_id || '',
        1 // Default to page 1
      );
    }
    
    // State initialization - matching reference exactly
    let dataLeave = this.props.listLeave;
    this.state = {
      dataLeave: dataLeave,
      page: 1,
      fruits: [],
      checkbox: false,
      // Phase 5: Pull-to-refresh state
      isRefreshing: false,
      startY: 0,
      currentY: 0,
      pullDistance: 0,
      confirmBoxPopupBeforeSession: false,
    };
  }

  componentDidMount() {
    console.log('AddingMinutesPage mounted');
    
    // Phase 5: Add touch event listeners for pull-to-refresh
    // Use a ref or timeout to ensure DOM is ready
    setTimeout(() => {
      const scrollContainer = document.querySelector('.addingminutes-page .page-content');
      if (scrollContainer) {
        scrollContainer.addEventListener('touchstart', this.handleTouchStart, { passive: false });
        scrollContainer.addEventListener('touchmove', this.handleTouchMove, { passive: false });
        scrollContainer.addEventListener('touchend', this.handleTouchEnd, { passive: false });
      }
    }, 100);
  }

  componentDidUpdate(prevProps: AddingMinutesPageProps) {
    // Phase 2: Handle timeslotsMake updates
    if (!this.props.isReschedule) {
      return;
    }
    if (!this.props.timeslotsMake) {
      return;
    }
    if (
      JSON.stringify(this.props.timeslotsMake) !==
      JSON.stringify(prevProps.timeslotsMake)
    ) {
      this.setState({
        fruits: this.props.timeslotsMake,
      });
      return;
    }
  }

  componentWillUnmount() {
    // Phase 5: Remove touch event listeners
    const scrollContainer = document.querySelector('.addingminutes-page .page-content');
    if (scrollContainer) {
      scrollContainer.removeEventListener('touchstart', this.handleTouchStart);
      scrollContainer.removeEventListener('touchmove', this.handleTouchMove);
      scrollContainer.removeEventListener('touchend', this.handleTouchEnd);
    }
    
    // Clear any pending timeouts
    if ((this as any).refreshTimeoutId) {
      clearTimeout((this as any).refreshTimeoutId);
    }
    if ((this as any).navigationTimeoutId) {
      clearTimeout((this as any).navigationTimeoutId);
    }
  }

  selectFruit = (e: any, id: number) => {
    // Phase 3: Selection logic
    if (
      this.state.fruits.some(
        (it: any) => it.appointment_timeslot_id == e.id && it.option_schedule == id
      )
    ) {
      // Remove selection if already selected
      const fruits = this.state.fruits.filter(
        (it: any) => it.appointment_timeslot_id != e.id || it.option_schedule != id
      );
      this.setState({ fruits });
      return;
    }

    // Check if maximum selections reached
    if (this.state.fruits.length >= 3) {
      return;
    }

    // Add new selection
    const fruits = this.state.fruits.concat([
      {
        appointment_timeslot_id: e.id,
        option_schedule: id,

        date: e.date,
        start_time: e.start_time,
        end_time: e.end_time,
      },
    ]);
    this.setState({ fruits });
  };

  _loadData = () => {
    // Phase 5: Load more data logic
    // This can be implemented for pagination if needed
  };

  _onRefresh = () => {
    // Refresh logic - matching reference exactly
    if (this.props.getListLeave && this.props.currentSettings?.child?.salesforce_contact_id) {
      this.props.getListLeave(
        this.props.currentSettings.child.salesforce_contact_id,
        1
      );
    }
    
    if (this.props.getTimeslots && this.props.leave_id && this.props.currentSettings?.child?.salesforce_contact_id) {
      this.props.getTimeslots(
        this.props.leave_id,
        this.props.isTherapist || false,
        this.props.currentSettings.child.salesforce_contact_id,
        this.props.isReschedule || false,
        this.props.make_id || '',
        this.state.page
      );
    }
  };

  _onNextPress = () => {
    // Phase 4: Next button logic
    const { fruits } = this.state;
    if (fruits.length < 3) {
      return;
    }

    // 48-hour check: slot must be at least 48 hours from now
    var isBeforeReschduleMinimumTime = false;
    this.state.fruits.forEach((fruit: any) => {
      if(isBeforeReschduleMinimumTime) return;

      const selectedDateString = fruit.date;
      const selectedSlotOption = fruit;
      if (selectedDateString && selectedSlotOption?.start_time) {
        const now = moment();
        const rawTime = String(selectedSlotOption.start_time).trim();
        const slotStartTime = rawTime.includes(' - ') ? rawTime.split(' - ')[0].trim() : rawTime;
        const slotStartTimeNormalized = slotStartTime.split(':').slice(0, 2).join(':');
        const selectedSlot = moment(`${selectedDateString} ${slotStartTimeNormalized}`, 'YYYY-MM-DD HH:mm');
        const timestampNow = now.unix();
        const MIN_SECONDS_BEFORE_SESSION = 48 * 60 * 60;  // 48 hours in seconds
        const timestampMinBeforeSession = timestampNow + MIN_SECONDS_BEFORE_SESSION;
        const timestampSelectedSlot = selectedSlot.unix();
        isBeforeReschduleMinimumTime = timestampSelectedSlot < timestampMinBeforeSession;
      }
    });

    if(isBeforeReschduleMinimumTime) {
      this.setState({ confirmBoxPopupBeforeSession: true });
    } else {
      this._moveToVerifyMackupSessionForBookingOrRescheduleMackupSession();
    }
  };

  _moveToVerifyMackupSessionForBookingOrRescheduleMackupSession = () => {
    const { fruits } = this.state;
    const { 
      currentSettings, 
      leave_id, 
      isTherapist, 
      isReschedule, 
      make_id, 
      code, 
      categoryId, 
      childId,
      updateMake,
      onNavigate 
    } = this.props;

    if (fruits.length < 3) {
      return;
    }

    // Prepare data for updateMake API
    let make = {
      salesforce_contact_id: currentSettings?.child?.salesforce_contact_id,
      leave_id: String(leave_id),
      timeslot_and_schedule: fruits,
      option: 2,
    };

    let makeTherapist = {
      salesforce_contact_id: currentSettings?.child?.salesforce_contact_id,
      therapist_leave_id: String(leave_id),
      timeslot_and_schedule: fruits,
      option: 2,
    };

    // Call updateMake API
    if (updateMake && make_id) {
      updateMake(make_id, isTherapist ? makeTherapist : make);
    }

    // Navigate to VerifyMakeUpSessionSchedulePage after delay - using query string
    const navigationTimeoutId = setTimeout(() => {
      if (onNavigate && this.state) { // Check if component is still mounted
        // Convert state to query string for better web parameter management
        const queryParams = new URLSearchParams({
          code: String(code || ''),
          categoryId: String(this.props.categoryId || ''),
          timeslotId: String(this.state.fruits.length > 0 ? this.state.fruits[0].appointment_timeslot_id : ''),
          childId: String(this.props.childId || ''),
          make_id: String(make_id || ''),
        });
        
        onNavigate(`calendar/verify-make-up-session-schedule?${queryParams.toString()}`);
      }
    }, 700);
    
    // Store timeout ID for cleanup
    (this as any).navigationTimeoutId = navigationTimeoutId;
  }

  handleGoBack = () => {
    if (this.props.onGoBack) {
      this.props.onGoBack();
    }
  };

  handleNavigate = (route: string, params?: any) => {
    if (this.props.onNavigate) {
      this.props.onNavigate(route, params);
    }
  };

  // Phase 5: Pull-to-refresh touch handlers
  handleTouchStart = (e: Event) => {
    const touchEvent = e as TouchEvent;
    const scrollContainer = document.querySelector('.addingminutes-page .page-content');
    if (scrollContainer && scrollContainer.scrollTop === 0) {
      this.setState({
        startY: touchEvent.touches[0].clientY,
        currentY: touchEvent.touches[0].clientY,
        pullDistance: 0,
      });
    }
  };

  handleTouchMove = (e: Event) => {
    const touchEvent = e as TouchEvent;
    const { startY, isRefreshing } = this.state;
    const scrollContainer = document.querySelector('.addingminutes-page .page-content');
    
    if (scrollContainer && scrollContainer.scrollTop === 0 && !isRefreshing) {
      const currentY = touchEvent.touches[0].clientY;
      const pullDistance = Math.max(0, currentY - startY);
      
      if (pullDistance > 0) {
        touchEvent.preventDefault();
        this.setState({
          currentY,
          pullDistance: Math.min(pullDistance, 100), // Max pull distance
        });
      }
    }
  };

  handleTouchEnd = () => {
    const { pullDistance, isRefreshing } = this.state;
    
    if (pullDistance > 50 && !isRefreshing) {
      // Trigger refresh
      this.setState({ isRefreshing: true });
      this._onRefresh();
      
      // Reset after refresh with proper cleanup
      const timeoutId = setTimeout(() => {
        if (this.state) { // Check if component is still mounted
          this.setState({
            isRefreshing: false,
            startY: 0,
            currentY: 0,
            pullDistance: 0,
          });
        }
      }, 1000);
      
      // Store timeout ID for cleanup
      (this as any).refreshTimeoutId = timeoutId;
    } else {
      // Reset without refresh
      this.setState({
        startY: 0,
        currentY: 0,
        pullDistance: 0,
      });
    }
  };

  render() {
    const { 
      t, 
      onGoBack, 
      onNavigate, 
      getTimeslotsFetching, 
      getTimeslotsSuccess, 
      getTimeslotsError,
      timeslotsNew,
      updateMakeFetching,
      updateMakeSuccess,
      updateMakeError
    } = this.props;
    const { fruits, isRefreshing, pullDistance } = this.state;

    // Phase 2: Use real data from Redux
    console.log('AddingMinutesPage render - timeslotsNew:', timeslotsNew);
    // Temporary sample data for testing
    /* const sampleTimeslots = [
      {
        id: 1,
        appointment_timeslot_id: 1,
        date: new Date().toISOString(),
        allow_schedule_option_one: true,
        allow_schedule_option_two: true,
      },
      {
        id: 2,
        appointment_timeslot_id: 2,
        date: new Date(Date.now() + 86400000).toISOString(), // Tomorrow
        allow_schedule_option_one: true,
        allow_schedule_option_two: false,
      },
      {
        id: 3,
        appointment_timeslot_id: 3,
        date: new Date(Date.now() + 172800000).toISOString(), // Day after tomorrow
        allow_schedule_option_one: false,
        allow_schedule_option_two: true,
      },
    ]; */
    const sampleTimeslots: any[] = [];
    const timeslots = Array.isArray(timeslotsNew) && timeslotsNew.length > 0 ? timeslotsNew : sampleTimeslots;
  

    console.log('AddingMinutesPage render - timeslots:', timeslots);

    return (
      <div className="addingminutes-page">
        {/* Header */}
        <div className="page-header">
          <div className="page-header-inner">
            <div className="header-left">
              <button 
                className="header-button back-button"
                onClick={onGoBack}
              >
                <ArrowLeft />
              </button>
              <h1 className="header-title">
                {t?.('verify-request:leave-request-list') || 'Leave Request List'}
              </h1>
            </div>
            <div className="header-right">
              <button 
                className={`header-button next-button ${fruits.length >= 3 ? 'enabled' : 'disabled'}`}
                disabled={fruits.length < 3}
                onClick={this._onNextPress}
              >
                {t?.('select-date-and-time-screen:header.right') || 'Next'}
              </button>
            </div>
          </div>
        </div>

        {/* Loading Indicator - Phase 2 */}
        {getTimeslotsFetching && (
          <div className="loading-container">
            <div className="loading-spinner"></div>
          </div>
        )}

        {/* Phase 6: Error Handling */}
        {getTimeslotsError && (
          <div className="error-container">
            <div className="error-message">
              <p>{t?.('common:error-loading-data') || 'Error loading data. Please try again.'}</p>
              <button 
                className="retry-button"
                onClick={this._onRefresh}
              >
                {t?.('common:retry') || 'Retry'}
              </button>
            </div>
          </div>
        )}

        {/* Phase 6: Update Make Error */}
        {updateMakeError && (
          <div className="error-container">
            <div className="error-message">
              <p>{t?.('common:error-updating-data') || 'Error updating data. Please try again.'}</p>
            </div>
          </div>
        )}

        {/* Phase 5: Pull-to-refresh indicator */}
        {isRefreshing && (
          <div className="refresh-indicator">
            <div className="refresh-spinner"></div>
            <p>{t?.('common:refreshing') || 'Refreshing...'}</p>
          </div>
        )}
          
        {/* Content */}
        <div className="page-content" style={{ transform: `translateY(${pullDistance * 0.5}px)` }}>
          <div className="timeslots-container">
            {/* Phase 6: Validation - Show message if no timeslots */}
            {getTimeslotsSuccess && !getTimeslotsFetching && timeslots.length === 0 && (
              <div className="no-data-container">
                <p>{t?.('common:no-data-available') || 'No time slots available.'}</p>
              </div>
            )}

            {/* Phase 6: Validation - Show selection count */}

            {getTimeslotsSuccess && !getTimeslotsFetching && Array.isArray(timeslots) && timeslots.map((item, index) => (
              <div key={index} className="timeslot-group">
                {/* Date Header */}
                <div className="date-header">
                  <span className="date-text">
                    {item?.date ? moment(item?.date).format("dddd") + " " + moment(item?.date).format("DD/MM/YYYY") : ""}
                  </span>
                </div>
            
                {/* Option 1 */}
                {item.allow_schedule_option_one && (() => {
                  const isOptionSelected = fruits.some(
                    (it: any) => it.appointment_timeslot_id === item.id && it.option_schedule === 1
                  );
                  const isDisabled = fruits.length >= 3 && !isOptionSelected;
                  return (
                    <div 
                      className={`option-card ${isDisabled ? 'disabled inactive-option' : 'selectable'}`}
                      onClick={() => !isDisabled && this.selectFruit(item, 1)}
                    >
                      <span className="option-text">
                        {t?.('select-leavere-quest:option-one') || 'Option 1: Adding 15 minutes before the session'}
                      </span>
                      <div className="checkbox-container">
                        {isOptionSelected ? (
                          <span className="check-1"></span>
                        ) : (
                          <span className="check-2"></span>
                        )}
                      </div>
                    </div>
                  );
                })()}

                {/* Option 2 */}
                {item.allow_schedule_option_two && (() => {
                  const isOptionSelected = fruits.some(
                    (it: any) => it.appointment_timeslot_id === item.id && it.option_schedule === 2
                  );
                  const isDisabled = fruits.length >= 3 && !isOptionSelected;
                  return (
                    <div 
                      className={`option-card ${isDisabled ? 'disabled inactive-option' : 'selectable'}`}
                      onClick={() => !isDisabled && this.selectFruit(item, 2)}
                    >
                      <span className="option-text">
                        {t?.('select-leavere-quest:option-two') || 'Option 2: Adding 15 minutes after the session'}
                      </span>
                      <div className="checkbox-container">
                        {isOptionSelected ? (
                          <span className="check-1"></span>
                        ) : (
                          <span className="check-2"></span>
                        )}
                      </div>
                    </div>
                  );
                })()}
            </div>
            ))}
          </div>
        </div>

        <ConfirmBox
          title={''}
          message={t?.('select-date-and-time-screen:alert.confirm-before-session.message') || 'Sessions booked within the coming 48 hours will not be able to be rescheduled.'}
          confirmAction={() => {
            this.setState({ confirmBoxPopupBeforeSession: false })
            this._moveToVerifyMackupSessionForBookingOrRescheduleMackupSession();
          }}
          cancelAction={() => this.setState({ confirmBoxPopupBeforeSession: false })}
          isVisible={this.state.confirmBoxPopupBeforeSession}
          onClose={() => {}}
          confirmText={String(t?.('select-date-and-time-screen:alert.confirm-before-session.continue') || 'Continue')}
          cancelText={String(t?.('common:cancel') || 'Cancel')}
        />

      </div>
    );
  }
}

// Redux connection - matching reference exactly
const mapStateToProps = (state: any) => {
  return {
    currentSettings: state.currentSettings,
    getListLeaveFetching: state.getListLeave.fetching,
    getListLeaveSuccess: state.getListLeave.success,
    getListLeaveError: state.getListLeave.error,
    listLeave: state.getListLeave.listLeave,
    getTimeslotsFetching: state.getTimeslots.fetching,
    getTimeslotsSuccess: state.getTimeslots.success,
    getTimeslotsError: state.getTimeslots.error,
    timeslotsNew: state.getTimeslots.timeslots,
    timeslotsMake: state.getTimeslots.timeslotsMake,
    updateMakeFetching: state.updateMake.fetching,
    updateMakeSuccess: state.updateMake.success,
    updateMakeError: state.updateMake.error,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    getTimeslots: (leave_id: string, isTherapist: boolean, children_id: string, isReschedule: boolean, makeId: string, page: number = 1) =>
      dispatch(GetTimeslotsActions.getTimeslotsRequest(leave_id, isTherapist, children_id, isReschedule, makeId, page)),
    getListLeave: (children_id: string, page: number) =>
      dispatch(GetListLeaveActions.getListLeaveRequest(children_id, page)),
    updateMake: (make_id: string, make: any) =>
      dispatch(UpdateMakeActions.updateMakeRequest(make_id, make)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AddingMinutesPage));
